<template>
  <div class="cert" ref="cert">
    <div class="cert__grade_and_name">
      <div class="cert__grade" v-show="fileName !== 'complete_trial'" v-text="grade" />
      <div class="cert__name">
        <input v-show="isShowBtn && isEditableName" type="text" v-model="name" placeholder="이름" ref="input" v-text="name" />
        <div v-show="!(isShowBtn && isEditableName)" v-text="name" />
      </div>
    </div>
    <div class="cert__date">{{ simpleDateFormat(new Date(), 'yyyy년  M월  dd일') }}</div>
    <div class="cert__btn-wrap">
      <div class="cert__btn cert__save-btn" @click="save" v-show="isShowBtn">
        <div>저장하기</div>
      </div>
      <div class="cert__btn cert__print-btn" @click="print" v-show="isShowBtn">
        <div>인쇄하기</div>
      </div>
    </div>
    <img class="background" :src="`/codmos/static/assets/logicong-study-resources/common/certificate/runner/${fileName}.png`">
  </div>
</template>

<script>
  import html2canvas from 'html2canvas'

  export default {
    name: 'certificateTemplate',
    data() {
      return {
        name: '',
        isShowBtn: true,
        isEditableName: true,
        types: {
          'basic': '기초',
          'deep1': '심화1',
          'deep2': '심화2',
          'complete': '완성',
        },
        grade: (() => {
            let grade;
            const userInfo = JSON.parse(this.getCookie(this.getCookie('isLogin') === 'true' ? 'loginUserInfo' : 'runNonLoginUserInfo') || '{}');

            const nowYear = new Date().getFullYear();
            const age = nowYear - (userInfo.birth_year || 2000) + 1;
            if (
                age < 8
                || age > 19
            ) {
                grade = '일반';
            } else if (age < 14) {
                grade = `초등 ${age - 7}학년`;
            } else if (age < 17) {
                grade = `중등 ${age - 13}학년`;
            } else if (age < 20) {
                grade = `고등 ${age - 16}학년`;
            }

            return grade;
        })(),
        certTy: '',
      }
    },
    computed: {
      fileName() {
        return this.certTy || 'complete_trial';
      }
    },
    methods: {
      close () {
        this.$emit('close')
      },
      save () {
        // 코딩파티 인증서 출력 함수
        if( typeof this.name === 'undefined' || this.name.trim() === '' )
        {
          this.$refs.input.focus();
          alert('이름을 입력해주세요.');
          return;
        }

        this.isShowBtn = false;
        this.$nextTick(() => {
          html2canvas(this.$refs.cert, {logging:false}).then(canvas => {
            const imgSrc =  canvas.toDataURL();
            let fileName = '';
            if (this.certTy) {
              fileName = `${new Date().getFullYear()}_코딩파티_달려라_펭수_${this.types[this.certTy]}_${this.name}.png`;
            } else {
              fileName = `달려라_펭수_완성_${this.name}.png`;
            }
            var imgData = atob(imgSrc.split(",")[1]),
                len = imgData.length,
                buf = new ArrayBuffer(len),
                view = new Uint8Array(buf),
                blob,
                i;

            for (i = 0; i < len; i++) {
                view[i] = imgData.charCodeAt(i) & 0xff // masking
            }

            blob = new Blob([view], {
                type: "application/octet-stream"
            });

            // ie
            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, fileName)
            } else {
                var a = document.createElement("a");
                a.href = imgSrc;
                a.download = fileName;
                document.body.appendChild(a)
                a.click();
                setTimeout(function() {
                    document.body.removeChild(a)
                }, 100)
            }

            this.isShowBtn = true;
          });
        })
      },
      print () {
        // 코딩파티 인증서 출력 함수
        if( typeof this.name === 'undefined' || this.name.trim() === '' )
        {
          this.$refs.input.focus();
          alert('이름을 입력해주세요.');
          return;
        }

        this.isShowBtn = false;
        this.$nextTick(() => {
          html2canvas(this.$refs.cert, {logging:false}).then(canvas => {
            this.isShowBtn = true;
            this.close();

            window.document.title = `온라인_코딩파티_달려라_펭수_${this.types[this.certTy]}_${this.name}`;
            window.print();
            window.onafterprint = () => {
              this.isShowBtn = true;
            };
          });
        })
      },
      calledFromOpener(data) {
        this.certTy = data.certTy;
      },
    },
    mounted () {
      if (opener) {
        opener.g_winPopup = this;
      }
      if (this.getCookie('isLogin') === 'true') {
        const userInfo = JSON.parse(this.getCookie('loginUserInfo') || '{}');
        if (userInfo.name) {
          this.name = userInfo.name;
          this.isEditableName = false;
        }
      }
      this.$refs.input.focus()
    }
  }
</script>

<style>
  #app {
    height: 100%;
  }

  html, body {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
  }
</style>

<style lang="less" scoped>
  @import "../../assets/styles/map/map_certificate";
</style>



// WEBPACK FOOTER //
// src/components/runner/MapPartialCertificate.vue